import { render } from "./CardLayoutComponent.vue?vue&type=template&id=238e7f41"
import script from "./CardLayoutComponent.vue?vue&type=script&lang=js"
export * from "./CardLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__